import { Golem } from "./golem";
export class GreenGolem extends Golem {
    constructor() {
        super(...arguments);
        this.cooldown = 1000;
    }
}
GreenGolem.displayName = "Green Golem";
GreenGolem.artUrl = "./assets/cards/greengolem.jpg";
GreenGolem.effect = {
    callback: () => { },
    description: "Consume a Rock and play a card every second",
    needsFeedback: true,
};
